module.exports = __webpack_public_path__ + "static/img/wxcode.577c63c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wxcode.jpg
// module id = yuSG
// module chunks = 0